import { render, staticRenderFns } from "./DetailCandidate.vue?vue&type=template&id=feddc8f0&scoped=true"
import script from "./DetailCandidate.vue?vue&type=script&lang=js"
export * from "./DetailCandidate.vue?vue&type=script&lang=js"
import style0 from "./DetailCandidate.vue?vue&type=style&index=0&id=feddc8f0&prod&lang=css"
import style1 from "./DetailCandidate.vue?vue&type=style&index=1&id=feddc8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feddc8f0",
  null
  
)

export default component.exports